import { render, staticRenderFns } from "./DepotButton.vue?vue&type=template&id=84999014"
import script from "./DepotButton.vue?vue&type=script&lang=js"
export * from "./DepotButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports